import {
  DateFragment,
  Duration,
  TimeOfDay,
  TimezoneRegion,
} from "@tento-chrono";
import { type SheetRow, SheetViewModel } from "@tento-lona";
import { DataAliasPlugin } from "../../data.ts";
import type { CalendarSubcolumnSpan } from "@tento-lona/sheets-ui/sheet/calendar-subcolumn.ts";
import type { TimepointCellEntry } from "@tento-lona/sheets";
import { Typography } from "@tento-ui/ui/typography";
import { SpanFlat } from "@tento-ui/components/span/components/span-flat";
import { Span as ContentSpan } from "@tento-ui/components/span/span";
import type { SheetBinder } from "../../../../sheet/sheet-index-renderer.ts";

export namespace SpanDebugFlat {
  export function makeSpan(
    cell: TimepointCellEntry,
  ): CalendarSubcolumnSpan {
    const $e = SpanFlat.make();
    $e.style.setProperty("--icon-bg", "transparent");

    const $icon = Typography.p("⏰");
    $icon.assignStyles({
      "--font-size": "var(--text-8px)",
      "--margin-top": "2px",
      marginLeft: "-0.5px",
    });
    $icon.style.setProperty("--font-size", "var(--text-8px)");
    $e.bind($icon);

    const end = cell.dtr.end;
    const minDur = end.durationSince(cell.dtr.start);
    return {
      id: cell.id,
      bindContent: ContentSpan.staticContent($e),
      start: cell.dtr.start,
      end: cell.dtr.start.add(minDur.max(Duration.Time.from({ mins: 25 }))),
      pointerEvents: "none",
      item: null,
      callbacks: null,
    };
  }

  export const makeSpansFactory =
    (
      plugin: DataAliasPlugin,
      sheet: SheetViewModel.Surface<SheetBinder>,
      row: SheetRow.Joined.Handle,
    ) =>
    async (
      windowed: DateFragment.Windowed,
      _tz: TimezoneRegion,
    ): Promise<CalendarSubcolumnSpan[]> => {
      const dtr = windowed.fragment.clamp(
        windowed.validHours ?? TimeOfDay.Range.DAY,
      );

      const cells = (await row.cells(dtr.toUtc())).filter((c) => c.kind === "timepoint");

      const $cells = cells.map(makeSpan);
      return $cells;
    };
}
